import { useQuery } from "@tanstack/react-query";
import {
  ApiException,
  OrderApprovalsClient,
  ProblemDetails,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";

const isNotFoundError = (error: unknown) =>
  (error instanceof ProblemDetails || error instanceof ApiException) &&
  error.status === 404;

/** Resolves to `null` when the approval does not exist or is not visible to the user. */
export function useWebOrderApprovalDetail(
  webOrderId: number | null,
  open: boolean,
) {
  const api = useApi(OrderApprovalsClient);
  return useQuery({
    queryKey: ["web-order-approval-detail", webOrderId],
    queryFn: async () => {
      try {
        return await api.getWebOrderApprovalDetail(webOrderId as number);
      } catch (error) {
        if (isNotFoundError(error)) {
          return null;
        }
        throw error;
      }
    },
    enabled: open && webOrderId != null && webOrderId > 0,
    staleTime: 5 * 60 * 1000,
  });
}
